// @flow
import React from 'react';
import { ReferralLinkVisit } from '../components/referrals/components/ReferralLinkVisit/ReferralLinkVisit';

function ReferralLinkLanding() {
  return <ReferralLinkVisit />;
}

export { ReferralLinkLanding };
